import { DocumentTitleSegment } from '@hooks/useDocumentContext';

export const getDocumentTitle = (segments: DocumentTitleSegment[]) =>
  segments
    .map(segment => segment.title)
    .reverse()
    .join(' – ');
